<app-modal-basic #modal [hideFooter]="true" (closed)="onClose()" modalContentId="modal-acompanhamento-nfe-do-pedido"
  dialogClass="modal-lg" [allowClickOutside]="false">
  <div class="app-modal-header">
    <h4 class="modal-title">
      Faturamento de NF-e via Pedido
    </h4>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>N° Pedido</th>
              <th>Cliente</th>
              <th>Valor do Pedido</th>
              <th>N° NF-e</th>
              <th>Status NF-e</th>
              <th *ngIf="parametrosNfe?.envioEmailAutomatico">E-mail</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pedido of pedidos">
              <td>{{pedido.numeroPedido}}</td>
              <td style="text-wrap: auto">{{pedido.cliente}}</td>
              <td>{{pedido.valorTotal | currency:'BRL':'symbol':'1.2-2'}}</td>
              <td>{{pedido.numeroNfe || '-'}}</td>
              <td style="text-align: center">
                <i class="fa fa-circle-notch fa-spin" *ngIf="pedido.statusNfe === '0'" ngbTooltip="Gerando NF-e"></i>
                <i class="fa fa-warning text-danger" *ngIf="pedido.statusNfe === 'E'" [ngbTooltip]="pedido.erro" container="body"></i>
                <i class="fa fa-check text-success" *ngIf="pedido.statusNfe === 'A'" ngbTooltip="Autorizada"></i>
                <i class="fa fa-regular fa-hourglass-half" *ngIf="pedido.statusNfe === 'N'"
                  ngbTooltip="Aguardando Ambiente Nacional - Consulte a Situação em Fiscal > NF-e > Consulta."></i>
              </td>
              <td style="text-align: center" *ngIf="parametrosNfe?.envioEmailAutomatico">
                <i class="fa fa-check text-success" *ngIf="pedido.statusEmail === 'OK'" ngbTooltip="E-mail enviado com sucesso"></i>
                <i class="fa fa-circle-notch fa-spin" *ngIf="pedido.statusEmail === 'ENVIANDO'" ngbTooltip="Enviando e-mail"></i>
                <i class="fa fa-warning text-danger" *ngIf="pedido.statusEmail === 'ERRO'" [ngbTooltip]="pedido.erroEmail" container="body"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button (click)="gerarNfe()" class="btn btn-primary" [disabled]="loading['gerarNfe'] || gerouNfe || loading['parametros']"
          [ngbTooltip]="gerouNfe ? 'NF-e já foram geradas' : null">
          <app-loading [loading]="loading['gerarNfe']" [icone]="'icofont icofont-file-alt'" [texto]="'Gerar NF-e'"></app-loading>
        </button>
        <button (click)="onClose()" class="btn btn-info" [disabled]="loading['gerarNfe']">
          <i class="ti ti-close"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</app-modal-basic>
